<template>
  <div class="cd603-chart common-border">
    <div class="common-border2" :style="{ height: `${height}px` }">
      <el-row class="header">
        <el-col :span="24">
          <span class="sensor-name">{{ name }}:</span>
          <span class="value">{{ lastValue }}</span>
          <span class="unit-name">{{ unitName }}</span>
        </el-col>
      </el-row>
      <el-row class="center mt-15" type="flex" justify="center" align="middle">
        <el-col tag="span" :span="12">{{ $t('安装状态') }}：{{ $t(status.install) }}</el-col>
        <el-col tag="span" :span="12">{{ $t('运行状态') }}：{{ $t(status.run) }}</el-col>
      </el-row>
      <el-row class="center" type="flex" justify="center" align="middle">
        <el-col tag="span" :span="12">
          {{ $t('故障状态') }}：
          <span :class="status.faultClass">{{ $t(status.fault) }}</span>
        </el-col>
        <el-col tag="span" :span="12">
          {{ $t('报警状态') }}：
          <span :class="status.alarmClass">{{ $t(status.alarm) }}</span>
        </el-col>
      </el-row>
      <el-row class="center" v-if="gasTypeName" type="flex" align="middle">
        <el-col tag="span" :span="12">{{ $t('气体类型') }}：{{ gasTypeName }}</el-col>
        <el-col tag="span" :span="12"></el-col>
      </el-row>

      <div class="chart-box">
        <v-chart
          :options="opt"
          :smoothTimeLine="ind === 0"
          :smoothTimeLineMax="maxLen"
          :autoresize="true"
        ></v-chart>
      </div>
    </div>
  </div>
</template>

<script>
import { lineAreaStyle } from '@/echartOption/lineAreaStyle';
import { barBasicStyle } from '@/echartOption/commonOpt';

import { graColor } from '@/views/realdata/FCBR-100/options';
import { tools } from '../utils';
import { formatTime } from '@/utils/date';

export default {
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    height: Number,
    ind: Number
  },
  inject: ['time'],
  data() {
    const lineOpt = lineAreaStyle({
      color: '#009fe9',
      dataZoom: {
        start: 0,
        type: 'inside'
      },
      series: [
        {
          symbol: 'emptyCircle',
          areaStyle: { color: graColor('rgb(3, 153, 224)', 'rgba(3, 153, 224, 0.1)') }
        }
      ],
      xAxis: {
        axisLine: {
          lineStyle: {
            color: '#009fe9'
          }
        }
      },
      yAxis: {
        max: null,
        boundaryGap: [0, 0.1]
      },
      grid: {
        top: 28,
        left: 30,
        right: 30,
        bottom: 20
      }
    });
    const barOpt = barBasicStyle({
      color: '#009fe9',
      dataZoom: {
        start: 0,
        type: 'inside'
      },
      tooltip: {
        formatter(params) {
          const value = params[0].value;

          return `${formatTime(value[0], 'hh:mm:ss')}<br />
          <span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#009fe9;"></span>
          ${value[1]}`;
        }
      },
      xAxis: {
        type: 'category',
        axisLine: {
          lineStyle: {
            color: '#009fe9'
          }
        },
        axisLabel: {
          formatter(value) {
            return formatTime(value, 'hh:mm:ss') + '';
          }
        }
      },
      grid: {
        top: 28,
        left: 30,
        right: 30,
        bottom: 20
      }
    });

    const list = [lineOpt, barOpt];

    return {
      maxLen: 30,
      name: '',
      unit: '',
      unitName: '',
      lastValue: '',
      gasTypeName: '',
      status: {
        install: '',
        run: '',
        alarm: '',
        fault: ''
      },
      chart: [],
      faker: {
        sns: [],
        valueRangeList: {
          'CS-R': [0.1, 0.15],
          CO: [11, 15],
          H2S: [1, 2]
        },
        transform: {
          H2S: {
            code: 'CH3',
            value: 0,
            unitName: 'PPB',
            name: '沙林',
            gasTypeName: ''
          }
        }
      },
      opt: list[this.ind]
    };
  },
  methods: {
    ...tools,
    modifyChart(data) {
      this.lastValue = data;
      if (this.chart.length >= this.maxLen + 1) this.chart.shift();
      this.chart.push([this.time.begin, data]);
      this.opt.series[0].data = this.chart;
    },
    dataFaker(n) {
      if (this.faker.sns.includes(this.$route.params.sn)) {
        const { valueRangeList, transform } = this.faker;

        if (n.code in transform) {
          Object.assign(n, transform[n.code]);
        }

        if (n.code in valueRangeList) {
          const [min, max] = valueRangeList[n.code];
          Object.assign(this.opt.yAxis, {
            min,
            max
          });
        }
      }
    },
    setState(n) {
      Object.assign(this, {
        name: n.name,
        unit: n.unit,
        unitName: n.unitName,
        gasTypeName: n.gasTypeName
      });

      Object.assign(this.status, {
        install: this.pumpInstallText(n.installState),
        run: this.pumpRunText(n.runstate),
        fault: this.pumpFaultText(n.faultState),
        faultClass: this.pumpFaultClass(n.faultState),
        alarm: this.pumpAlarmText(n.alarmState),
        alarmClass: this.pumpAlarmClass(n.alarmState)
      });
    },
    setData(n) {
      this.setState(n);
      this.modifyChart(n.value);
    },
    setDataList(list, data) {
      this.setState(data);

      this.chart.push(...list.map(e => [e.beginTime, e.value]));
      this.opt.series[0].data = this.chart;
    }
  },
  watch: {
    data: 'setData'
  }
};
</script>

<style lang="scss">
.cd603-chart {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  padding: 4px;
  .header {
    font-size: 18px;
    background: #013c5d;
    padding: 12px 10px;
    border-radius: 4px;
    font-weight: bold;

    .sensor-name,
    .value,
    .unit-name {
      margin-right: 5px;
    }

    .unit-name {
      font-size: 12px;
    }
  }
  .center {
    padding: 5px;
    font-size: 16px;
    .el-col {
      text-align: center;
    }
  }
  .chart-box {
    height: calc(100% - 140px);
  }
}
</style>
